import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { postAsync } from "../../services/ApiHandler";
import { useHeaderStore } from "../../parts/CommonHeader";
import { isLoggedIn } from "../../services/CookieHandler";

export const CreditAddedPage: FC = () => {
  const search = useLocation().search;
  const { fetchRemainCount } = useHeaderStore();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const sessionId = query.get('session_id');
    if (sessionId !== undefined && isLoggedIn()) {
      postSessionId(sessionId!.toString());
    }
  }, []);

  async function postSessionId(sessionId: string) {
    const param = {
      sessionId: sessionId
    };
    await postAsync<string>("Stripe/CompletePurchase", param); 
    fetchRemainCount();
  }

  return <>
    <Helmet>
      <title>クレジット追加購入完了</title>
      <meta name="description" content="クレジット追加購入完了" />
    </Helmet>
      <div className="mt-4 text-base sm:text-lg font-bold">クレジット追加購入の申込が完了しました！</div>
  </>;
}
